import { makeApi, type ZodiosErrorByAlias } from "@zodios/core";

import { openAiApi } from "./ai/index.ts";
import { contentApi } from "./content.ts";
import { contentLanguagesApi } from "./contentLanguages.ts";
import { interactModulesApi } from "./interactModules.ts";
import { interactModuleSetsApi } from "./interactModuleSets.ts";
import { languagesApi } from "./languages.ts";
import { nodesApi } from "./nodes.ts";
import { nodeTemplateCategoriesApi } from "./nodeTemplateCategories.ts";
import { nodeTemplatesApi } from "./nodeTemplates.ts";
import { permissionsApi } from "./permissions.ts";
import { thumbnailApi } from "./thumbnailApi.ts";
import { transportApi } from "./transportApi.ts";

// Hack to resolve TS2742. `import type {} from ...` works too, but gets automatically removed as unused :(
export type * as Data from "@skilitics/nautilus-core-designer-data";
export type * as DataSchemas from "@skilitics/nautilus-core-designer-data/schemas";
export * from "./ai/index.ts";
export type { ContentLanguage } from "./contentLanguages.ts";
export {
  moduleSetSchema,
  moduleSetUpdateSchema,
  type InteractModuleSet,
  type UpdateInteractModuleSet,
} from "./interactModuleSets.ts";
export {
  moduleActionSchema,
  moduleForbiddenSchema,
  moduleListItemSchema,
  moduleOpenUserSchema,
  moduleSchema,
  type InteractModuleListItem,
  type InteractModuleProperties,
  type InteractModuleResource,
  type InteractModuleResourceProperties,
  type ModuleAction,
  type ModuleForbidden,
  type ModuleOpenUser,
  type UpdateInteractModule,
  type UpdateModuleSessionOptions,
} from "./interactModules.ts";
export type { Language } from "./languages.ts";
export type { NodeTemplateCategory } from "./nodeTemplateCategories.ts";
export { nodeTemplateBodySchema, nodeTemplatePatchSchema } from "./nodeTemplates.ts";
export type {
  ModuleNodeTemplateScope,
  NodeFilter,
  NodeTemplate,
  NodeTemplateBody,
  NodeTemplatePatch,
  NodeTemplateQueryParams,
  NodeTemplateScope,
  NodeTemplateScopeType,
  SystemNodeTemplateScope,
  UserNodeTemplateScope,
} from "./nodeTemplates.ts";
export { postNodeRequestBodySchema, type PostNodeRequestBody } from "./nodes.ts";
export type { Permissions } from "./permissions.ts";

export const api = makeApi([
  ...languagesApi,
  ...interactModulesApi,
  ...interactModuleSetsApi,
  ...contentLanguagesApi,
  ...contentApi,
  ...transportApi,
  ...nodesApi,
  ...openAiApi,
  ...nodeTemplatesApi,
  ...thumbnailApi,
  ...nodeTemplateCategoriesApi,
  ...permissionsApi,
]);

export type RevisionMismatchResponse = ZodiosErrorByAlias<typeof api, "postNodeDesignsRevision", 409>;
